export const PAGE_VIEW_NON_TRACKABLE_URLS = [
  '/en/services/payment-breakdown',
  '/en/services/payment-status',
  '/ar/services/payment-breakdown',
  '/ar/services/payment-status'
];
